import { useContext } from 'react'

import { ModalContext, SidebarModal } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useNewOrder from './hooks/useNewOrder'

import DefaultState from './screens/DefaultState'
import FavouriteOrderFlow from './screens/FavouriteOrderFlow'
import OrderBundleFlow from './screens/OrderBundleFlow'
import PackageFlow from './screens/PackageFlow'
import PublicationFlow from './screens/PublicationFlow'
import StandardFlow from './screens/StandardFlow'

export type UseNewOrderPayload = ReturnType<typeof useNewOrder>

const MODAL_KEY = 'NewOrderModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const NewOrderModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})

  const {
    agencyId,
    campaignId,
    campaignProposalId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    existingOrderId,
    isDefaultQuoteItem,
    providerId,
    quoteSectionId,
    redirect,
    serviceId,
  } = modalPayload

  const newOrderPayload = useNewOrder({
    agencyId,
    campaignId,
    campaignProposalId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    existingOrderId,
    isDefaultQuoteItem,
    providerId,
    quoteSectionId,
    redirect,
    serviceId,
  })

  const {
    isPublication,
    selectedService,
    state: {
      selectedServiceId,
    },
  } = newOrderPayload

  return (
    <SidebarModal
      callbacks={callbacks}
      clickSafeZone
      modalKey={MODAL_KEY}
      showModal={showModal}
      size="large"
    >
      <SidebarModal.Header
        callbacks={callbacks}
        title={isDefaultQuoteItem || campaignQuoteId || campaignQuoteTemplateId ? 'Orderable' : 'Order New'}
        titleSecondLine="Item"
      />

      {!selectedServiceId && (
        <DefaultState newOrderPayload={newOrderPayload} />
      )}

      {selectedServiceId === 'bundles' && (
        // @ts-expect-error TS2741
        <OrderBundleFlow callbacks={callbacks} newOrderPayload={newOrderPayload} />
      )}

      {selectedServiceId === 'favourites' && (
        // @ts-expect-error TS2741
        <FavouriteOrderFlow callbacks={callbacks} newOrderPayload={newOrderPayload} />
      )}

      {selectedServiceId === 'packages' && (
        // @ts-expect-error TS2741
        <PackageFlow callbacks={callbacks} newOrderPayload={newOrderPayload} />
      )}

      {isPublication && !isDefaultQuoteItem && (
        // @ts-expect-error TS2741
        <PublicationFlow callbacks={callbacks} newOrderPayload={newOrderPayload} />
      )}

      {!isPublication && !!selectedService.id && (
        // @ts-expect-error TS2741
        <StandardFlow callbacks={callbacks} newOrderPayload={newOrderPayload} />
      )}
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <NewOrderModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
